"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParticipatingGroups = exports.getFoundedGroups = exports.getUserGroups = void 0;
const getUserGroups = (state) => {
    return state || [];
};
exports.getUserGroups = getUserGroups;
const getFoundedGroups = (state) => {
    return (state === null || state === void 0 ? void 0 : state.filter(group => group.isFounder)) || [];
};
exports.getFoundedGroups = getFoundedGroups;
const getParticipatingGroups = (state) => {
    return (state === null || state === void 0 ? void 0 : state.filter(group => !group.isFounder)) || [];
};
exports.getParticipatingGroups = getParticipatingGroups;
